(function () {

    module.exports = {
        init: init,
        chapter: chapter,
    }
 //   var appData = require("../data/data.json")
    var appData;
    var chapterControls = require("./modules/chapter.js")

//    var copyData = appData.copy;
    var copyData;
    var copy = {};
    var current_page;

    function init(data) {
        appData = data
        copyData = appData.copy
        console.log(copyData)
        routie({
            '/:lang':home,
            '/:lang/intro':intro,
            '/:lang/convite':story,
            '/:lang/resources':database,
            '/:lang/resources?:query':database,
            '/:lang/chapter/:number':chapter,
            '/:lang/strategies/:strategy':strategies,
            '/:lang/strategies':strategies,
            '/:lang/toolkit': toolkit,
        })
    }

    function home(lang) {
        setLanguage(lang)
        loadTemplate('landing', '#main-view-container', copy);
        $("#main-view-container").fadeIn();
    }

    var popUpOpen = false
    setMenus()

    function setMenus() {
        $('.lang-btn').click(function() {
            if($(this).hasClass('es')) {
                routie('/es/')
            } else {
                routie('/en/')
            }
        })
        $('.menu-popup-btn').click(function() {
            if(popUpOpen === true) {
                $(".pop-up-container").remove();
            } else {
                popUpOpen = true
            }
            page = $(this).attr('data-template')
            appendTemplate(page, '#main-view-container', copy)
            setTimeout(function() {
                $(".sub-menu-btn").click(function() {
                    template = $(this).attr('data-template');
                    if(template == 'people') {
                      people = {rows: []}
                      row = {cols: []}
                      var i = 1
                      console.log(appData.people)
                      for (p in appData.people) {
                        row.cols.push(appData.people[p])
                        if (i % 5 == 0) {
                          people.rows.push(row)
                          row = {cols: []};
                        }
                        i++
                      }
                      if ($(this).text() == 'Team' || $(this).text() == 'Equipo' ) {
                        people.title = copyData.filter(function(l) { return l.id == 'team'})[0][currentLang]
                      } else {
                        people.title = copyData.filter(function(l) { return l.id == 'partners'})[0][currentLang]
                      }
                      console.log(people)
                      tData = people
                    } else {
                      tData = {}
                    }
                  if($(this).attr('data-premise')) {
                    premise = $(this).attr('data-premise')
                    for(d in copyData) {
                      if(copyData[d].id.substr(0,8) == 'premise' + premise ) {
                        tData[copyData[d].id] = copyData[d][currentLang]
                      }
                    }
                    tData.title = tData['premise'+premise+'title']
                    tData.text = tData['premise'+premise]
                    tData.img = tData['premise'+premise+'img']

                    //                    tData = copy.filter(function(l) { return substring(0, 8, l.id) == 'premise' + premise;})
                    console.log(tData)
                  }
                  loadTemplate(template, '.pop-up-section', tData)
                  setTimeout(function() {
                    $(".person-image").click(function() {
                      var uid = $(this).attr('data-uid');
                      tem = appData.people.filter(function(l) { return l.uid == uid;});
                      console.log(tem)
                      $(".people-info").html(Mustache.render("<p>{{name}}</p>{{bio}}<br />{{#href}}<a href='{{.}}'>{{/href}}<strong>{{org}}</strong>{{#href}}</a>{{/href}}", tem[0]))
                    })
                  },600)
                })
              $(".pop-up-close").click(function () {
                popUpOpen = false
                $(".pop-up-container").css('top', '-100vh')
                setTimeout(function () {
                  $('.pop-up-container').remove();
                }, 1300)
              })
            },500)
        })
    }

  function intro(lang) {
    setLanguage(lang)
    $('#main-view-container').fadeOut(function() {
      loadTemplate('intro', '#main-view-container', copy)
      $("#main-view-container").fadeIn()
      setTimeout(function() {
        audio = document.getElementById('intro-vid');
        track = audio.textTracks[0];
        track.mode = "hidden";
        //      add_transcript(track);
        track.oncuechange = function() {
          cue = this.activeCues[0];
          $(".subtitle-container").text(cue.text)
        }

        $(".intro-container video").on('ended', function() {
          $("#main-view-container").fadeOut(function() {
            routie('/'+lang+'/convite')
            $('#main-view-container').fadeIn();
          })
        })
        $(".skip-button").click(function(){
          routie('/'+currentLang+'/convite')
        })
      }, 600)
    })
  }

  var storyStart = true

  var krpano = null;

  function krpano_onready_callback(krpano_interface)
  {
    krpano = krpano_interface;
  }

  function story(lang) {
    setLanguage(lang)
    chapterControls.init(c)
    loadTemplate('convite', '#main-view-container', copy)
    setTimeout(function() {
      embedpano({swf:"vtour/tour.swf", xml:"vtour/tour.xml", target:"pano", html5:"auto", mobilescale:1.0, passQueryParameters:true, consolelog: true, onready:krpano_onready_callback});
      $("#main-view-container").fadeIn();
      $('#pano').click(function() {
        if(storyStart == true) {
          storyStart = false
          $('.pano-overlay').fadeOut(1500, function () {
            $('.pano-overlay-content').html(Mustache.render('<h1>{{instruction2}}</h1><img class="instruction-img" src="vtour/skin/arrow-y.png" />', copy))
            $('.pano-overlay').fadeIn();
          })
          setTimeout(function () {
            $('.pano-overlay').fadeOut(1500, function () {
              $('.pano-overlay-content').html(Mustache.render('<h1>{{instruction3}}</h1><img class="instruction-img" src="vtour/skin/hotspot-gr.png" />', copy))
              $('.pano-overlay').fadeIn();
            })
            setTimeout(function() {
              $('.pano-overlay').fadeOut(function() {
                krpano.call("actions.tween(hotspot[actorSpot].alpha | hotspot[timelineSpot].alpha | hotspot[mapsSpot].alpha | hotspot[spacesSpot].alpha | hotspot[towersSpot].alpha | hotspot[housingSpot].alpha | hotspot[cameraSpot].alpha | hotspot[manSpot].alpha, 1, 1)")
              });
            }, 4000)
          }, 5000)
        }
      })
    }, 700)

  }

  window.addOverlay = function(hotspot) {
    console.log(hotspot)
    $(".story-overlay").remove()
    $("#chapter-view-container").append("<div class='story-overlay'></div>").css("display", "block").css("pointer-events", "auto")
    $("#chapter-view-container").click(function() {
      $(".story-overlay").fadeOut(function() {
        $(this).remove()
      }).parent().css("pointer-events", "none")
    })
    hs = appData.hotspots.filter(function(l) { return l.uid == hotspot})[0]
    if(hs.type == 'text') {
      $(".story-overlay").css("width", "60vh").css("height", "60vh").css("left", "33%").css("top", "25%")
    } else {
      $(".story-overlay").css("width", "150%").css("height", "150%").css("left", "-25%").css("top", "-25%")
    }
    args = { copy: copy, info: hs}
    loadTemplate('overlay--'+hs.type, '.story-overlay', hs)
    setTimeout(function() {
      $(".story-overlay-content").fadeIn()
    },1000)
  }

  function chapter(lang, number) {
    setLanguage(lang)
    chapData = appData.slides.filter(function(l) { return l.chapter == number;})
    chapterControls.init(chapData, copy)
  }

  function overlayChapter(number) {
    console.log(number)
    chapData = appData.slides.filter(function(l) { return l.chapter == number;})
    console.log(chapData)
    chapterControls.constructChapter(chapData)
  }

  window.chapter = overlayChapter;

  function database(lang, query) {
    setLanguage(lang)
    $("#chapter-view-container").html('')
    if(query){
      terms = query.substr(3,query.length - 3).split('=')
      terms[1] = terms[1].replace(/_/g, ' ')
      console.log(terms)
      library = appData.resources.filter(function(l) { return l[terms[0]] == terms[1];})
      console.log(library)
      resources = findResources(library)
    } else {
      resources = findResources(appData.resources)
    }
    //        console.log(query.substr(3,query.length - 3))
    resources['copy'] = copy
    loadTemplate('database', '#main-view-container', resources);
    $("#main-view-container").fadeIn();
    setTimeout(function(){
      $('.filter-title').click(function(){
        if($(this).hasClass('active')) {
          $(this).removeClass('active').next().css('height', '0px')
        } else {
          $(this).addClass('active').next().css('height', 'auto')
        }
      })
    },600)
  }

  function toolkit(lang) {
    setLanguage(lang)
    $("#chapter-view-container").html('')
    console.log('toolkit')
    $.ajax({
      url: 'coinvite-toolkit-master/index.html',
      cache: false
      // dataType: "json"
    }).done(function(data) {
      console.log(data)
      $("#main-view-container").html(Mustache.render(data, copy));
      $("#main-view-container").fadeIn()
    });
  }

  function findResources(fData) {
    allResources = {rows:[]}
    row = {cols:[]}
    var i = 1
    for(r=0;r<12;r++) {
      if(r>fData.length-1) {
        row.cols.push({})
      } else {
        if (fData[r].mediaType == 'Youtube') {
          url = fData[r].url
          sections = url.split('?v=')
          fData[r].url = sections[1]
        }
        row.cols.push({resource:fData[r]})

      }
      if (i % 4 == 0) {
        allResources.rows.push(row)
        row = {cols: []};
      }
      i++
    }
    return allResources
  }

  var strategyData = {
    risk: {icon: 'risk_mitigation', title:'Risk Mitigation'},
    tenure: {icon: 'tenure', title:'Security of Tenure'},
    housing: {icon: 'housing_quality', title:'Housing Quality'},
    infrastructure: {icon: 'infrastructure', title:'Infrastructure Provision'},
    livelihoods: {icon: 'livelihoods', title:'Livelihoods'},
    participation: {icon: 'participation', title:'Political Participation'},
    planning: {icon: 'spatial_planning', title:'Spatial Planning Networks'},
    funding: {icon: 'funding', title:'Funding Mechanisms'},
    data: {icon: 'data', title:'Data Generation'},
    memory: {icon: 'memory', title:'Collective Memory & Reparation'},
  }

  function strategies(lang, strategy) {
    console.log(strategy)
    setLanguage(lang)
    if(strategy != undefined) {
      loadTemplate('strategies-individual', '#main-view-container', strategyData[strategy])
    } else {
      loadTemplate('strategies', '#main-view-container', copy)
    }
    $("#main-view-container").fadeIn()
  }

  var currentLang
  function setLanguage(lang) {
    currentLang = lang
    console.log(appData)
    loadTemplate('header', '.header', copy)
    setTimeout(function() {
      setMenus()
    },600)
    for(c in copyData) {
      term = copyData[c]
      copy[term.id] = term[lang]
    }
    for(h in appData.hotspots) {
      appData.hotspots[h].text = appData.hotspots[h]['text_'+lang]
      appData.hotspots[h].title = appData.hotspots[h]['title_'+lang]

    }

    for(h in appData.slides) {
      appData.slides[h].content = appData.slides[h]['content_'+lang]
    }
    copy['lang'] = lang
  }

  function loadTemplate(template, target, args) {
    $.ajax({
      url: 'templates/'+template+'.html',
      cache: false
      // dataType: "json"
    }).done(function(data) {
      $(target).html(Mustache.render(data, args));
    });
  }

  function appendTemplate(template, target, args) {
    $.ajax({
      url: 'templates/'+template+'.html',
      cache: false
      // dataType: "json"
    }).done(function(data) {
      $(target).append(Mustache.render(data, args));
    });
  }

})();
